<template>
    <v-card>
        <v-card-text>
            <h2 class="mb-1" v-if="authUser.name">{{ authUser.name }}</h2>
            <h5
                class="text-uppercase font-weight-light"
                v-if="$_.get(authUser, 'company.name')"
            >
                {{ authUser.company.name }}
            </h5>
            <!-- TODO: Implement Password Reminder Alert -->
            <v-row
                class="justify-center align-stretch fill-height"
                v-if="false"
            >
                <v-col cols="9">
                    <v-alert
                        prominent
                        icon="mdi-alert"
                        border="top"
                        dismissible
                        dark
                        color="warning darken-2"
                        >Your password expires in 7 days.</v-alert
                    >
                </v-col>
            </v-row>
            <v-row class="justify-center align-stretch fill-height">
                <v-col cols="7">
                    <template v-for="(item, index) in items">
                        <div :id="item.id" :key="index">
                            <component
                                :dataLoading="dataLoading"
                                :updateError="updateError"
                                :is="item.component"
                                :user="authUser"
                                @update="update"
                            ></component>
                        </div>
                    </template>
                </v-col>
                <v-col cols="2">
                    <psi-scroll-nav
                        v-if="items.length > 0"
                        :items="items"
                    ></psi-scroll-nav>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "account-profile",
    components: {
        UpdateProfile: () => import("./Profile/UpdateProfile.vue"),
        ChangePassword: () => import("./Profile/ChangePassword.vue"),
        RolePermissions: () => import("./Profile/RoleAndPermissions"),
        RingCentral: () => import("./Profile/RingCentral"),
        MyDetails: () => import("./Profile/MyDetails"),
        UpdateProperties: () => import("./Profile/UpdateProperties"),
        UpdatePhoto: () => import("./Profile/UploadPhoto.vue"),
    },
    data() {
        return {
            profile: {},
        };
    },

    computed: {
        ...mapGetters("Users", ["menus", "dataLoading", "updateError"]),
        items() {
            const menuItem = this.$_.get(this.menus, "account", []).find(
                (menu) => menu.id === "account-profile"
            );
            const items =
                menuItem === undefined
                    ? []
                    : menuItem.children.map((item) => {
                          return {
                              ...item,
                              component: item.id,
                          };
                      });

            return items;
        },
    },
    watch: {},
    methods: {
        ...mapActions("Users", ["updateUser"]),
        ...mapMutations("Users", ["SET_UPDATE_ERROR"]),
        update(user_id, data) {
            this.SET_UPDATE_ERROR("");
            this.updateUser({
                user_id,
                data,
            });
        },
    },
    mounted() {
        this.SET_UPDATE_ERROR("");
    },
};
</script>
<style scoped>
</style>
